import { render } from "./TeoServers.vue?vue&type=template&id=1994c9b1"
import script from "./TeoServers.vue?vue&type=script&lang=js"
export * from "./TeoServers.vue?vue&type=script&lang=js"

import "./TeoServers.vue?vue&type=style&index=0&id=1994c9b1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__